import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as ClearBtn } from "@client/components/reusable/SvgIcons/library/clear_btn.svg";
import { ReactComponent as SearchIconSmall } from "@client/components/reusable/SvgIcons/library/search_icon_small.svg";
import { ReactComponent as SearchIcon } from "@client/components/reusable/SvgIcons/library/search_icon.svg";
import { useRootContext } from "@client/context/RootContext";

const HeaderSearch = observer(() => {
	const {
		vendorStore: { pullingDataInProgress },
		layoutStore: {
			setSearchTerm,
			searchTerm,
			searchTermError,
			submitSearch,
			isSearchInputFocused,
			searchInput_focus,
			searchInput_blur,
		},
	} = useRootContext();

	const inputSearchRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (isSearchInputFocused) {
			inputSearchRef.current?.focus();
		}
	}, [isSearchInputFocused]);

	return (
		<div className="menu-search-wrapper">
			<input
				ref={inputSearchRef}
				id="menu-input-search"
				className={classNames("menu-input-search", {
					["on-focus"]: isSearchInputFocused || searchTerm,
					invalid: !!searchTermError && isSearchInputFocused,
				})}
				disabled={pullingDataInProgress}
				onChange={(event) => setSearchTerm(event.currentTarget.value)}
				value={searchTerm}
				onKeyDown={(event) => {
					if (event.key === "Enter") {
						submitSearch();
					}
				}}
				onFocus={searchInput_focus}
				onBlur={searchInput_blur}
			/>

			<SvgIcon
				onClick={() => {
					if (searchTerm.trim()) {
						submitSearch();
					} else if (!pullingDataInProgress) {
						searchInput_focus();
					}
				}}
				component={
					isSearchInputFocused || searchTerm ? SearchIconSmall : SearchIcon
				}
				width={isSearchInputFocused || searchTerm ? "12" : "20"}
				height={isSearchInputFocused || searchTerm ? "12" : "20"}
				className="menu-search-icon"
				style={{
					left: isSearchInputFocused || searchTerm ? "16px" : "14px",
					top: isSearchInputFocused || searchTerm ? "40%" : "30%",
					cursor: pullingDataInProgress ? "not-allowed" : "pointer",
				}}
			/>

			{pullingDataInProgress && (
				<div className="menu-search-loading-overlay" aria-hidden>
					<span
						className={classNames("menu-search-loading-spinner", {
							["small"]: isSearchInputFocused || searchTerm,
						})}
					/>
				</div>
			)}

			{searchTerm && (
				<span
					onMouseDown={(event) => {
						// Keep input focused so clear click does not trigger onBlur logic.
						event.preventDefault();
					}}
				>
					<SvgIcon
						component={ClearBtn}
						className={classNames("menu-search-clear-btn", {
							disabled: pullingDataInProgress,
						})}
						onClick={() => {
							setSearchTerm("");
							searchInput_focus();
						}}
					/>
				</span>
			)}

			{!!searchTermError && isSearchInputFocused && (
				<div className="menu-search-error">{searchTermError}</div>
			)}
		</div>
	);
});

export default HeaderSearch;
